module.exports = __webpack_public_path__ + "img/banner_title.f9bffd04.png";